class NdFaqAccordion extends HTMLElement {
  connectedCallback() {
    this.details = Array.from(this.querySelectorAll('details.nd-faq__item'));
    this.details.forEach((detail) => {
      detail.addEventListener('toggle', this.onToggle.bind(this));
    });
  }

  onToggle(event) {
    if (!event.target.open) return;

    this.details.forEach((detail) => {
      if (detail !== event.target) {
        detail.removeAttribute('open');
      }
    });
  }
}

customElements.define('nd-faq-accordion', NdFaqAccordion);
